import { contractConstants } from '../../constants'

const initialState = {
  data: [],
  status: [],
  select:[],
  recordItems:[],
  isLoading: false,
  isFailure: false,
  isRecord: false,
  isRecordOpen: false,
  isKeepOpen: false,
}

export default function contract(state = initialState, action) {
  switch (action.type) {

    /*********
     상태조회
    **********/

    case contractConstants.STATUS_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case contractConstants.STATUS_SUCCESS:
      return {
        ...state,
        status: action.response.data
      }
    case contractConstants.STATUS_FAILURE:
      return {
        isLoading: false,
        isFailure: true
      }

    /*********
     리스트
    **********/

    case contractConstants.LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case contractConstants.LOAD_SUCCESS:
      console.log(action.response.data.payload)
      return {
        ...state,
        data: action.response.data.payload
      }
    case contractConstants.LOAD_FAILURE:
      return {
        isLoading: false,
        isFailure: true
      }

    /*********
     선택
    **********/

    case contractConstants.SELECT_REQUEST:

      window.open('/canvasNew/composeViewer_new.htm?menuId=104&cntrctNo='+ action.params, '_blank')

      return {
        ...state,
        isLoading: !state.isLoading,
      }

    /*********
     삭제
    **********/

    case contractConstants.DELETE_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case contractConstants.DELETE_SUCCESS:

      // 필터링후 재배치...
      let data = state.data['data'].filter(item => item['cntrctNo'] !== action.response.data['contract'].cntrctNo)
      state.data['data'] = data
      // 필터리훙 재배치 끝...

      return {
        ...state,
        data: state.data,
        isLoading: false
      }
    case contractConstants.DELETE_FAILURE:
      return {
        isLoading: false,
        isFailure: true
      }

    /*********
     컨펌
    **********/

    case contractConstants.CONFIRM_REQUEST:
      return {
        isLoading: !state.isLoading,
      }
    case contractConstants.CONFIRM_SUCCESS:
      return {
        isLoading: false
      }
    case contractConstants.CONFIRM_FAILURE:
      return {
        isLoading: false,
        isFailure: true
      }

    /*********
     보관
    **********/

    case contractConstants.KEEP_OPEN:
      return {
        ...state,
        isLoading: !state.isLoading,
        isKeepOpen: true,
      }
    case contractConstants.KEEP_SUCCESS:
      return {
        ...state,
        isKeepOpen: true,
      }
    case contractConstants.KEEP_FAILURE:
      return {
        isLoading: false,
        isFailure: true
      }
    case contractConstants.KEEP_CLOSE:
      return {
        isKeepOpen: false
      }

    /*********
     검색
    **********/

    case contractConstants.SEARCH_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case contractConstants.SEARCH_SUCCESS:
      return {
        ...state,
        data: action.response.data,
        // searchItems: action.response.data,
        isLoading: false
      }
    case contractConstants.SEARCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /*********
     레코드
    **********/

    case contractConstants.RECORD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case contractConstants.RECORD_SUCCESS:
      return {
        ...state,
        isLoading: !state.isLoading,
        recordItems: action.response.data,
        isRecordOpen: !state.isRecordOpen
      }
    case contractConstants.RECORD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }
    case contractConstants.RECORD_CLOSE:
      return {
        ...state,
        isRecordOpen: !state.isRecordOpen,
      }

    /*********
     다운로드
    **********/

    case contractConstants.DOWNLOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case contractConstants.DOWNLOAD_SUCCESS:
      return {
        ...state,
        recordItems: action.response.data,
        isLoading: false
      }
    case contractConstants.DOWNLOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }
    default:
      return state
  }
}
